import * as React from "react";

const SvgPartlyCloud = (props) => (
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <clipPath clipPathUnits="userSpaceOnUse" id="PartlyCloud_svg__a">
        <path d="M766.19 404.905c0-7.16 5.803-12.963 12.962-12.963 7.16 0 12.964 5.803 12.964 12.963 0 7.159-5.804 12.963-12.964 12.963-7.159 0-12.962-5.804-12.962-12.963" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="PartlyCloud_svg__b">
        <path d="M0 943.388h1828.656V0H0Z" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="PartlyCloud_svg__c">
        <path d="M770.609 394.18c-.052.001-.105.004-.159.004a8.288 8.288 0 0 1 0-16.576h20.6a6.696 6.696 0 0 1 0 13.393c-.023 0-.045-.003-.069-.004-.596 5.34-5.122 9.493-10.621 9.493-4.343 0-8.078-2.592-9.751-6.31" />
      </clipPath>
    </defs>
    <g
      clipPath="url(#PartlyCloud_svg__a)"
      style={{
        fill: "#fec025",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -971.05 578.317)"
    >
      <g
        style={{
          fill: "#fec025",
          fillOpacity: 1,
        }}
      >
        <path
          d="M766.19 404.905c0-7.16 5.803-12.963 12.962-12.963 7.16 0 12.964 5.803 12.964 12.963 0 7.159-5.804 12.963-12.964 12.963-7.159 0-12.962-5.804-12.962-12.963"
          style={{
            fill: "#fec025",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#PartlyCloud_svg__b)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -971.05 578.317)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="M0 0c5.889 0 10.664 4.774 10.664 10.664 0 5.889-4.775 10.663-10.664 10.663-.037 0-.073-.005-.109-.005-.949 8.504-8.158 15.116-16.915 15.116-6.916 0-12.864-4.125-15.529-10.048-.084.002-.167.006-.252.006-7.289 0-13.198-5.909-13.198-13.198C-46.003 5.909-40.094 0-32.805 0"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "none",
          }}
          transform="translate(776.833 377.608)"
        />
      </g>
    </g>
    <g
      clipPath="url(#PartlyCloud_svg__c)"
      style={{
        fill: "#d2e9f8",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -971.05 578.317)"
    >
      <g
        style={{
          fill: "#d2e9f8",
          fillOpacity: 1,
        }}
      >
        <path
          d="M770.609 394.18c-.052.001-.105.004-.159.004a8.288 8.288 0 0 1 0-16.576h20.6a6.696 6.696 0 0 1 0 13.393c-.023 0-.045-.003-.069-.004-.596 5.34-5.122 9.493-10.621 9.493-4.343 0-8.078-2.592-9.751-6.31"
          style={{
            fill: "#d2e9f8",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <path
      style={{
        opacity: 0.996721,
        fill: "none",
        stroke: "none",
        strokeWidth: 0.878738,
        strokeLinejoin: "round",
        paintOrder: "stroke fill markers",
      }}
      transform="matrix(1.33333 0 0 1.33333 -192 1257.85)"
      d="M144-943.388h72v72h-72z"
    />
  </svg>
);

export default SvgPartlyCloud;
